export function getDefaultStartTime() {
    let outDate = new XDate(new Date());
    return outDate.toString("yyyy-MM-dd");
}

export function getDefaultEndTime() {
    let outDate = new XDate(new Date());
    return outDate.addDays(1).toString("yyyy-MM-dd");
}

export function getDefaultDate(date) {
    if (date === null) return;
    let outDate = new XDate(date);
    return outDate.toString("yyyy-MM-dd");
}

export function getDefaultDatenew(date) {
    if (date === null) return;
    let outDate = new XDate(date);
    return outDate.toString("yyyy/MM/dd");
}

export function formatDate(date) {
    if (date === null) return;
    let outDate = new XDate(new Date());
    let year = new Date(date).getFullYear()
    let getMonth = new Date(date).getMonth() + 1
    let Day = new Date(date).getDate()
    if (getMonth < 10) {
        getMonth = '0' + getMonth
    } else {
        getMonth = getMonth
    }
    let arr = [{
            id: '01',
            name: 'January'
        },
        {
            id: '02',
            name: 'February'
        },
        {
            id: '03',
            name: 'March'
        },
        {
            id: '04',
            name: 'April'
        },
        {
            id: '05',
            name: 'May'
        },
        {
            id: '06',
            name: 'June'
        },
        {
            id: '07',
            name: 'July'
        },
        {
            id: '08',
            name: 'August'
        },
        {
            id: '09',
            name: 'September'
        },
        {
            id: '10',
            name: 'October'
        },
        {
            id: '11',
            name: 'November'
        },
        {
            id: '12',
            name: 'December'
        }
    ]
    let month = ''
    arr.forEach(item => {
        if (item.id == getMonth) {
            month = item.name
        }
    })
    return month + ' ' + Day + ', ' + year
}

export function formatDatey(date) {
    let outDate = new XDate(date);

    return outDate.toString("yyyy年MM月dd日");
}

export function formatDateTime(date) {
    let outDate = new XDate(date);

    return outDate.toString("yyyy-MM-dd HH:mm:ss");
}

export function formatDateTimes(date) {
    let outDate = new XDate(date);
    return outDate.toString("HH:mm:ss");
}

export function formatDay(date) {
    var aDate, oDate1, oDate2, iDays
    let sDate1 = new XDate(date).toString("yyyy-MM-dd");
    let sDate2 = new XDate().toString("yyyy-MM-dd");

    aDate = sDate1.split("-")
    oDate1 = new Date(aDate[0], aDate[1], aDate[2]) //转换为12-18-2006格式  
    aDate = sDate2.split("-")
    oDate2 = new Date(aDate[0], aDate[1], aDate[2])
    iDays = parseInt(Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 / 24) //把相差的毫秒数转换为天数  
    return iDays
}


export function toFixedEight(x, index) {
    if (x.toString().indexOf('.') !== -1) {
        if (x.toString().split(".")[1].length > index) {
            x = x.toFixed(index)
        }
    }
    return x
}


export function formatDateDay() {
    // if (date === null) return;
    let outDate = new XDate(new Date());
    let year = new Date(outDate).getFullYear()
    let getMonth = new Date(outDate).getMonth() + 1
    let Day = new Date(outDate).getDate()
    if (getMonth < 10) {
        getMonth = '0' + getMonth
    } else {
        getMonth = getMonth
    }
    let arr = [{
            id: '01',
            name: 'January'
        },
        {
            id: '02',
            name: 'February'
        },
        {
            id: '03',
            name: 'March'
        },
        {
            id: '04',
            name: 'April'
        },
        {
            id: '05',
            name: 'May'
        },
        {
            id: '06',
            name: 'June'
        },
        {
            id: '07',
            name: 'July'
        },
        {
            id: '08',
            name: 'August'
        },
        {
            id: '09',
            name: 'September'
        },
        {
            id: '10',
            name: 'October'
        },
        {
            id: '11',
            name: 'November'
        },
        {
            id: '12',
            name: 'December'
        }
    ]
    let month = ''
    arr.forEach(item => {
        if (item.id == getMonth) {
            month = item.name
        }
    })
    return month + ' ' + Day + ', ' + year
}